import Vue from 'vue';
import Router from 'vue-router';
import UUID from 'vue-uuid'; // to create random ids
import PortalVue from 'portal-vue';
import VueCarousel from 'vue-carousel';
import VueI18n from 'vue-i18n';

import 'jsbarcode/dist/JsBarcode.all.min';
import '@/mixins/global_notification_mixin';
import '@/plugins/global_components';
import '@/plugins/sentry';
import '@/plugins/bus';
import '@/plugins/upload';
import '@/plugins/graphql';
import '@/plugins/debugging';

import CONSTANTS from '@/constants/constants';
import MODELS from '@/constants/models';

Vue.prototype.$production = process.env.VUE_APP_ENVIRONMENT === 'production';
Vue.prototype.$api_url = process.env.VUE_APP_API_URL;
Vue.prototype.$CONSTANTS = CONSTANTS;
Vue.prototype.$MODELS = MODELS;

// 3rd party plugins
Vue.use(Router);
Vue.use(PortalVue); // https://linusborg.github.io/portal-vue/#/guide
Vue.use(UUID); // allows generating random strings in components with this.$uuid.v5()
Vue.use(VueCarousel); // https://ssense.github.io/vue-carousel/guide/
Vue.use(VueI18n);

Vue.config.productionTip = false;
